<div>
  <h4 class="card-title">{{title}}</h4>
  <div class="d-flex justify-content-between">
    <div class="p-3" style="width: 75%;" *ngIf="!isModifyDisabled">
      <div class="row" *ngIf=" HasProdottiDropdown">

        <div *ngIf="personalizzazioni == 'prodotto' && !environment.ProgettiAddon['ModaleAggiuntaProdotti']"
          class="col-lg-4">
          <ng-multiselect-dropdown [settings]="dropdownSettings" [placeholder]="'Prodotto'" [data]="prodotti"
            [(ngModel)]="prodottiSelezionati" (onFilterChange)="filtroProdtto($event)">
          </ng-multiselect-dropdown>
        </div>
        <div class="d-flex align-items-center" *ngIf="HasAddButton && personalizzazioni == 'prodotto'">
          <button class="btn btn-outline-info " style="width: 100%;" [disabled]="AddLoadingMsg"
            (click)="add(ProdottiModal)" type="button">
            {{ AddLoadingMsg != "" && AddLoadingMsg ? AddLoadingMsg : 'Aggiungi'}}
            <i class="fas fa-spin fa-spinner" *ngIf="AddLoadingMsg != '' && AddLoadingMsg"></i>
          </button>
        </div>

        <div *ngIf="personalizzazioni == 'personalizzazione'" class="col-lg-4">
          <ng-multiselect-dropdown [settings]="dropdownSettings" [placeholder]="'Personalizzazione'"
            [data]="personalizzazioniList" [(ngModel)]="personalizzazione"></ng-multiselect-dropdown>
        </div>

        <div *ngIf="personalizzazioni == 'sconto'" class="col-lg-4">
          <input [(ngModel)]="codSconto" placeholder="CodiceSconto" type="text" name="CodiceSconto"
            class="form-control">
        </div>

        <div *ngIf="personalizzazioni == 'coupon'" class="col-lg-4">
          <input [(ngModel)]="codSconto" placeholder="Coupon" type="text" name="Coupon" class="form-control">
        </div>

        <div class="d-flex align-items-center" *ngIf="HasAddButton && personalizzazioni != 'prodotto'">
          <button class="btn btn-outline-info " style="width: 100%;" [disabled]="AddLoadingMsg"
            (click)="addPersonalizzazioni()" type="button">
            {{ AddLoadingMsg ?? 'Aggiungi'}}
            <i class="fas fa-spin fa-spinner" *ngIf="AddLoadingMsg"></i>
          </button>
        </div>



        <div class="d-flex align-items-center ml-3"
          *ngIf="(environment.ProgettiAddon['addProdotti'] != false && (environment.ProgettiAddon['personalizzazioni'] || environment.ProgettiAddon['codiciSconto'] || environment.ProgettiAddon['coupon'])) && HasProdottiDropdown">
          <div class="radio d-flex align-items-center" *ngIf="environment.ProgettiAddon['addProdotti'] != false">
            <input type="radio" id="0" name="Radio0" [(ngModel)]="personalizzazioni" [value]="'prodotto'" />
            &nbsp;
            <label for="0">Prodotti</label>
          </div>
          &nbsp;&nbsp; &nbsp;&nbsp;
          <div class="radio d-flex align-items-center" *ngIf="(environment.ProgettiAddon['personalizzazioni'])">
            <input type="radio" id="1" name="Radio1" [(ngModel)]="personalizzazioni" [value]="'personalizzazione'" />
            &nbsp;
            <label for="1">{{'Personalizzazioni'}}</label>
          </div>
          &nbsp;&nbsp; &nbsp;&nbsp;
          <div class="radio d-flex align-items-center" *ngIf="environment.ProgettiAddon['coupon']">
            <input type="radio" id="2" name="Radio1" [(ngModel)]="personalizzazioni" [value]="'coupon'" />
            &nbsp;
            <label for="2">{{'Coupon'}}</label>
          </div>
          &nbsp;&nbsp; &nbsp;&nbsp;
          <div class="radio d-flex align-items-center" *ngIf="environment.ProgettiAddon['codiciSconto'] ">
            <input type="radio" id="3" name="Radio1" [(ngModel)]="personalizzazioni" [value]="'sconto'" />
            &nbsp;
            <label for="3">{{'Codici Sconto'}}</label>
          </div>
        </div>

      </div>
      <div class="row" *ngIf=" !HasProdottiDropdown && externalAddFunction != undefined">

        <div class="d-flex align-items-center" *ngIf="HasAddButton ">
          <button class="btn btn-outline-info " style="width: 100%;" [disabled]="AddLoadingMsg"
            (click)="add(ProdottiModal)" type="button">
            {{ AddLoadingMsg != "" && AddLoadingMsg ? AddLoadingMsg : 'Aggiungi'}}
            <i class="fas fa-spin fa-spinner" *ngIf="AddLoadingMsg != '' && AddLoadingMsg"></i>
          </button>
        </div>
        <div class="ml-auto d-flex align-items-center" *ngIf="HasAddButton && HasAddSconto">
          <button class="btn btn-outline-info " [disabled]="AddLoadingMsg" (click)="AddSconto()" type="button">
            {{'Aggiungi Sconto'}}
          </button>
          <input type="number" class="form-control" [(ngModel)]="ScontoValue">
        </div>

      </div>
    </div>
    <div class="ml-auto">
      <div class="d-flex justify-content-end" *ngIf="HasTotale">
        <span class="text-dark font-16 ">Totale: {{CalcTotSconto().totaleSenzaSconto | number: '2.2-2'}} €</span>
      </div>
      <div class="d-flex justify-content-end" *ngIf="HasTotale && CalcTotSconto().visibile">
        <span class="text-dark font-16 ">Sconto: {{CalcTotSconto().sconto | number: '2.2-2'}} €</span>
      </div>
      <div class="d-flex justify-content-end" *ngIf="HasTotale && CalcTotSconto().visibile">
        <span class="text-dark font-16 ">Totale Scontato: {{ getTotale(myProp.voci) | number: '2.2-2'}} €</span>
      </div>
      <div class="d-flex justify-content-end" *ngIf="HasTotale && HasIva">
        <span class="text-dark font-16">IVA: {{getIva(myProp.voci) | number: '2.2-2'}} €</span>
      </div>
      <div class="d-flex justify-content-end" *ngIf="HasTotale && HasIva">
        <span class="text-dark font-16">Totale + IVA: {{getTotaleIvato(myProp.voci) | number: '2.2-2'}} €</span>
      </div>
    </div>
  </div>



  <div class="table-responsive">
    <table class="table bg-white table-hover align-middle " style="margin-bottom: 70px;">
      <thead>
        <tr>
          <th scope="col" *ngIf="environment.ProgettiAddon['coupon']">Coupon</th>
          <th ngbTooltip="Prodotto Ordinato">Voce</th>
          <th *ngIf="environment.ProgettiAddon.categoriaVoceDiCosto" scope="col">Categoria</th>
          <th scope="col">Quantità</th>
          <th scope="col" *ngIf="environment.ProdottiAddOn['taglie'] && hastaglia()">Taglia</th>
          <th scope="col" ngbTooltip="Prezzo per unità" *ngIf="HasPrezzo">Prezzo</th>
          <th scope="col" ngbTooltip="Unità di misura" *ngIf="HasUm">UM</th>
          <th scope="col" ngbTooltip="Percentuale iva da applicare" *ngIf="HasIva">IVA % </th>
          <th scope="col" ngbTooltip="valore in euro dell'iva applicata" *ngIf="HasIva">IVA € </th>
          <th scope="col" ngbTooltip="Prezzo Imponibile per unità" *ngIf="HasImponibile">Imponibile</th>
          <th scope="col" ngbTooltip="Prezzo IVATO per unità" *ngIf="HasIva && HasIvato">Ivato</th>
          <th scope="col" ngbTooltip="Prezzo Totale " *ngIf="HasTotaleRiga">Totale</th>
          <th scope="col" ngbTooltip="Inserisci Qui il Coupon associato al prodotto"
            *ngIf="environment.ProgettiAddon['codiciSconto']">Coupon</th>
          <th scope="col" [style]="campo.titleStyle" [class]="campo.titleClass" *ngFor="let campo of CampiAggiuntivi">{{
            campo.nome | translate }}</th>
          <th scope="col">Azioni</th>
        </tr>
      </thead>
      <tbody style="font: message-box;">
        <tr *ngFor="let item of myProp.voci">
          <td class="align-middle" *ngIf="environment.ProgettiAddon['coupon']">
            {{item?.couponObject?.prodotto}}
          </td>
          <td>
            <span *ngIf="!item.modifica || !voceEditabile">{{ item.voce }}</span>
            <span *ngIf="item.modifica && voceEditabile">
              <input [(ngModel)]="item.voce" placeholder="voce" type="text" name="voce" class="form-control">
            </span>
          </td>
          <td *ngIf="environment.ProgettiAddon.categoriaVoceDiCosto">
            <span>
              <ng-multiselect-dropdown [disabled]="!item.modifica || !voceEditabile"
                [settings]="CategorieDropdownSettings" [placeholder]="'Categoria'" [data]="Categorie"
                [(ngModel)]="item.categorieSelezionate">
              </ng-multiselect-dropdown>
            </span>
          </td>
          <td class="align-middle">
            <span *ngIf="!item.modifica ">
              {{ item.quantita}}
            </span>
            <span *ngIf="item.modifica ">
              <input [(ngModel)]="item.quantita" placeholder="quantita" type="number" name="quantita"
                class="form-control">
            </span>
          </td>
          <td *ngIf="environment.ProdottiAddOn['taglie'] && hastaglia()">
            <span>{{ item.tagliaObject?.taglia }}</span>
          </td>
          <td class="align-middle" *ngIf="HasPrezzo">
            <span *ngIf="!item.modifica || !prezzoEditabile || !permission.HasnotCapacity(['is-cliente-ordine']) ">
              {{ item.prezzo | number: '2.2-2'}}&nbsp;€
            </span>
            <span *ngIf="item.modifica && prezzoEditabile && permission.HasnotCapacity(['is-cliente-ordine'])">
              <input [(ngModel)]="item.prezzo" placeholder="Prezzo" type="number" name="prezzo" class="form-control">
            </span>
          </td>
          <td class="align-middle" *ngIf="HasUm">
            <span
              *ngIf="!item.modifica && item?.um_id && getum(item)|| !permission.HasnotCapacity(['is-cliente-ordine']) ">{{
              getum(item).label}}</span>
            <span *ngIf="item.modifica && permission.HasnotCapacity(['is-cliente-ordine'])">
              <ng-multiselect-dropdown [settings]="unitadropdownSettings" [placeholder]="'Unita di misura'"
                [data]="getUM_LIST(item)" [(ngModel)]="item.um">
              </ng-multiselect-dropdown>
            </span>
          </td>
          <td class="align-middle" *ngIf="HasIva">
            <span *ngIf="!item.modifica && item?.prezzo >= 0|| !permission.HasnotCapacity(['is-cliente-ordine']) ">
              {{ item.iva}}
            </span>
            <span *ngIf="item.modifica && item?.prezzo >= 0 && permission.HasnotCapacity(['is-cliente-ordine'])">
              <input [(ngModel)]="item.iva" placeholder="iva" type="number" name="iva" class="form-control">
            </span>
          </td>
          <td class="align-middle" *ngIf="HasIva" (click)='edit(item, ProdottiModModal)'>
            <span *ngIf="!item.modifica && item?.prezzo >= 0">
              {{ getIvaPrice(item) | number: '2.2-2'}}&nbsp;€
            </span>
            <span *ngIf="item.modifica">
            </span>
          </td>
          <td class="align-middle" *ngIf="HasImponibile" (click)='edit(item, ProdottiModModal)'>
            <span *ngIf="(((item.prezzo/100 )*40) > getPrezzoUnitaRiga(item)) && item?.prezzo >= 0"
              class="badge badge-pill px-3   font-14" [ngStyle]="{'color': '#ffffff' , 'background-color': '#ff0000'}"
              ngbTooltip="Sconto applicato maggiore del 60 %">
              {{ getPrezzoUnitaRiga(item) | number: '2.2-2'}}&nbsp;€
            </span>
            <span *ngIf="!((item.prezzo/100 )*40 > getPrezzoUnitaRiga(item)) && item?.prezzo >= 0">
              {{ getPrezzoUnitaRiga(item) | number: '2.2-2'}}&nbsp;€
            </span>
          </td>
          <td class="align-middle" *ngIf="HasIva && HasIvato" (click)='edit(item, ProdottiModModal)'>
            <span
              *ngIf="!item.modifica && getNettoPrice(item) >= 0 && item?.prezzo >= 0 && ((getNettoPrice(item)/100 )*40 > (getPrezzoUnitaRiga(item) + ((getPrezzoUnitaRiga(item)/100)*item.iva)))"
              class="badge badge-pill px-3   font-14" [ngStyle]="{'color': '#ffffff' , 'background-color': '#ff0000'}"
              ngbTooltip="Sconto applicato maggiore del 60 %">
              {{ getPrezzoUnitaRiga(item) + getIvaPrice(item) | number: '2.2-2'}}&nbsp;€
            </span>
            <span *ngIf="!item.modifica && getNettoPrice(item) < 0 && item?.prezzo >= 0"
              class="badge badge-pill px-3   font-14" [ngStyle]="{'color': '#ffffff' , 'background-color': '#207120'}">
              {{ (getPrezzoUnitaRiga(item) + getIvaPrice(item)) ?? '0' | number: '2.2-2'}}&nbsp;€
            </span>
            <span
              *ngIf="!item.modifica && !((getNettoPrice(item)/100 )*40 > (getPrezzoUnitaRiga(item) + ((getPrezzoUnitaRiga(item)/100)*item.iva))) && item?.prezzo >= 0">
              {{ (getPrezzoUnitaRiga(item) + getIvaPrice(item)) ?? '0' | number: '2.2-2'}}&nbsp;€
            </span>
            <span *ngIf="item.modifica">
            </span>
          </td>
          <td class="align-middle" *ngIf="HasTotaleRiga">
            {{ getTotaleRiga(item) | number: '2.2-2'}}
          </td>
          <td class="align-middle" *ngIf="environment.ProgettiAddon['codiciSconto']">
            <input type="text" *ngIf="getNettoPrice(item) >= 0" style="" required [(ngModel)]="item.codiceSconto"
              class="form-control" id="codiceSconto" (focusout)="chkSconto(item)" (keyup.enter)="chkSconto(item)"
              [placeholder]="'Codice Sconto' | translate">
          </td>
          <td class="align-middle" *ngFor="let campo of CampiAggiuntivi">
            <div style="display: flex;
    flex-direction: row;
    justify-content: space-around;">
              <ng-container *ngFor="let oggetto of campo.oggetti">
                <span [style]="campo.style" [class]="campo.class" *ngIf="!campo.modificabile || !item.modifica ">
                  <span *ngIf="campo.icon" class="badge badge-light text-dark rounded-pill font-16 mr-1">
                    <i class="fas" [ngClass]="campo.icon"></i>
                  </span>
                  <ng-template [ngIf]="campo.inputType != 'date'">
                    <app-field-viewer [Campi]="[campo]" [hideLabel]="true" [Oggetto]="item"></app-field-viewer>
                  </ng-template>
                  <ng-template [ngIf]="campo.inputType == 'date'">
                    {{item[oggetto] | date: 'dd/MM/yyyy'}}
                  </ng-template>
                  <span *ngIf="campo.type == 'boolean'" [class.text-danger]="!item[oggetto]"
                    [class.text-success]="item[oggetto]">
                    <i *ngIf="campo.type == 'boolean'" [class.far]="!item[oggetto]"
                      [class.fa-times-circle]="!item[oggetto]" [class.fas]="item[oggetto]"
                      [class.fa-check-circle]="item[oggetto]"></i>
                  </span>
                </span>
                <span *ngIf="campo.modificabile && item.modifica">
                  <input [(ngModel)]="item[oggetto]" [placeholder]="campo.nome" [type]="campo.inputType"
                    class="form-control">
                </span>
                <span style="margin-left: 20px;" *ngIf="oggetto == 'spedizione'">
                  <ng-template #tipContentss>
                    <ng-container *ngIf="CostiTrasporto">
                      <!--                      <div class="d-flex justify-content-between align-items-center"  *ngFor="let costo of CostiTrasporto">-->
                      <!--                        <span class="text-dark font-16">{{costo.regione}}: </span>-->
                      <!--                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-->
                      <!--                        <a href="javascript:void(0)" *ngFor="let prezzo of costo.prezzi" class="link text-info " (click)="SetTrasporto(p1, item, prezzo)">-->
                      <!--                          <span  >{{prezzo | number: '2.2-2'}} €&nbsp;&nbsp;</span>-->
                      <!--                        </a>-->
                      <!--                      </div>-->

                      <div class="table-responsive" style="min-width: 500px; max-height: 400px;">
                        <table class="table bg-white table-hover align-middle ">
                          <tbody>
                            <tr *ngFor="let costo of CostiTrasporto">
                              <td>
                                <span class="text-dark font-16">{{costo.regione}}:</span>
                              </td>
                              <td *ngFor="let prezzo of costo.prezzi">
                                <a href="javascript:void(0)" class="link text-info "
                                  (click)="SetTrasporto(p1, item, prezzo)">
                                  <span>{{prezzo | number: '2.2-2'}} €&nbsp;&nbsp;</span>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="!CostiTrasporto">
                      <div class="d-flex justify-content-between align-items-center">
                        <span class="text-dark font-16">Caricamento dei costi in corso ... <i
                            class="fas fa-spin fa-calculator"></i> </span>
                      </div>
                    </ng-container>
                  </ng-template>
                  <a href="javascript:void(0)" [ngbPopover]="tipContentss" [autoClose]="'outside'" triggers="manual"
                    placement="top" #p1="ngbPopover" ngbTooltip="Calcola Trasporto" popoverTitle="Calcola Trasporto"
                    (click)="CalcolaTrasporto(p1, item)" class="link font-16 text-danger font-weight-bold">
                    <i class="fas fas fa-calculator"></i>
                  </a>

                </span>
                <span style="margin-left: 20px;" *ngIf="oggetto == 'disponibilitaProdotto'">
                  <a href="javascript:void(0)" ngbTooltip="Ricalcola" (click)="CalcolaDisponibilita(item)"
                    class="link font-16 text-danger font-weight-bold">
                    <i class="fas fas fa-sync" [ngClass]="{ 'spin': item.disponibilitaProdotto > 0 }"></i>
                  </a>
                </span>
              </ng-container>
            </div>


          </td>
          <td class="align-middle">
            <a *ngIf="!item.modifica && HasEditButton && getNettoPrice(item) >=0 && !isModifyDisabled"
              href="javascript:void(0)" ngbTooltip="Modifica" class="link font-16 text-info font-medium mr-2"
              (click)='edit(item)'>
              <i-feather name="edit-3" class="feather-sm"></i-feather>
            </a>
            <a *ngIf="item.modifica && HasEditButton && !isModifyDisabled" href="javascript:void(0)" ngbTooltip="Salva"
              class="link font-16 text-success font-medium mr-2" (click)='edit(item)'>
              <i-feather name="check" class="feather-sm"></i-feather>
            </a>
            <a *ngIf="!item.modifica && HasDeleteButton && !isModifyDisabled" href="javascript:void(0)"
              ngbTooltip="Elimina" class="link font-16 text-danger font-weight-bold" (click)='delete(item)'>
              <i-feather name="trash-2" class="feather-sm"></i-feather>
            </a>
            <a *ngIf="item.modifica && HasDeleteButton && !isModifyDisabled" href="javascript:void(0)"
              ngbTooltip="annulla" class="link font-16 text-danger font-weight-bold" (click)='delete(item)'>
              <i class="fas fas fa-times"></i>
            </a>
            <a *ngFor="let bottone of BottoniAggiuntivi" href="javascript:void(0)" [ngbTooltip]="bottone.tooltip"
              class="link font-16 font-weight-bold" [style.color]="bottone.color"
              (click)='bottone.onClick.emit({item:item, padre:myProp})'>
              <i class="fas" [ngClass]="bottone.icon"></i>
            </a>
            <ng-container *ngFor="let bottone of VociCostoButtons">
              <a href="javascript:void(0)" *ngIf="campoUtility.ButtonShow(bottone, item)" [ngbTooltip]="bottone.tooltip"
                class="link font-20 font-weight-bold" [style.color]="bottone.color"
                (click)='ChangeHandler(bottone.ExternalOnClick, item, bottone)'>
                <i class="fas" [ngClass]="bottone.icon"></i>
                &nbsp;
              </a>
            </ng-container>
            <a *ngIf="HasDuplicaButton && !item['idProdottoNeutro'] && (item['prezzo'] > 0) && !isModifyDisabled"
              href="javascript:void(0)" ngbTooltip="Duplica" class="link font-16 text-info font-weight-bold"
              (click)='duplicaClick(item)'>
              <i class="fas fa-copy"></i>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="d-flex justify-content-end" *ngIf="HasTotale">
    <span class="text-dark font-16 ">Totale: {{CalcTotSconto().totaleSenzaSconto | number: '2.2-2'}} €</span>
  </div>
  <div class="d-flex justify-content-end" *ngIf="HasTotale && CalcTotSconto().visibile">
    <span class="text-dark font-16 ">Sconto: {{CalcTotSconto().sconto | number: '2.2-2'}} €</span>
  </div>
  <div class="d-flex justify-content-end" *ngIf="HasTotale && CalcTotSconto().visibile">
    <span class="text-dark font-16 ">Totale Scontato: {{ getTotale(myProp.voci) | number: '2.2-2'}} €</span>
  </div>
  <div class="d-flex justify-content-end" *ngIf="HasTotale && HasIva">
    <span class="text-dark font-16">IVA: {{getIva(myProp.voci) | number: '2.2-2'}} €</span>
  </div>
  <div class="d-flex justify-content-end" *ngIf="HasTotale && HasIva">
    <span class="text-dark font-16">Totale + IVA: {{getTotaleIvato(myProp.voci) | number: '2.2-2'}} €</span>
  </div>
</div>


<ng-template #ProdottiModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="editUserLabel">Prodotti</h5>
    <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <app-lista-prodotti-card [tipoProgetto]="myProp['tipoProgetto']"
      (AddClick)="addProdotti($event)"></app-lista-prodotti-card>
  </div>
</ng-template>

<ng-template #ProdottiModModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="editUserLabel">Prodotto</h5>
    <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="inbox-panel p-2 bg-white">
      <ul class="list-group custom-group message-center" id="sidebar">
        <li class=" list-group-item " style="padding-right: 0; padding-bottom: 0;"
          *ngFor="let Variazioni of listaVariazioni">
          {{Variazioni.categoria}}
          <ul *ngIf="Variazioni.parti && Variazioni.parti.length > 0" class="list-group custom-group message-center"
            id="sidebar">
            <!-- Second level menu -->
            <li class="list-group-item  " style="padding-right: 0; padding-bottom: 0;"
              *ngFor="let item of Variazioni.parti">
              <div class="row">
                <span class="col-10">{{item.nome}} </span>
                <div class="col-lg-1 col-2">
                  <input type="checkbox" id="checkbox4" [(ngModel)]="item.selected"
                    (ngModelChange)="onVariazioneSelect(item)">
                  <label for="checkbox4"></label>
                </div>
              </div>

            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</ng-template>